module.exports = __webpack_public_path__ + "static/media/logo-houze-invest.ff0abd72.svg";